import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'anterasoftware-kanban-production-calendar-dialog',
  templateUrl: './kanban-production-calendar-dialog.component.html',
  styleUrls: ['./kanban-production-calendar-dialog.component.scss']
})
export class KanbanProductionCalendarDialogComponent implements OnInit {

  public equipments: any[] = [];

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<KanbanProductionCalendarDialogComponent>, @Inject(MAT_DIALOG_DATA) public data:any) { 
    this.equipments = this.data?.equipments || [];
  }

  public editFlag = false;
  public form = this.fb.group({
    machineId: [''],
    scheduleDate: ['']
  })

  ngOnInit(): void {
    this.editFlag = this.data.panel ? true : false;
    this.setFormValues();
  }

  public setFormValues(): void{
    const values = {
      machineId: this.data?.machineId || '',
      scheduleDate: this.data?.scheduleDate || '',
    };

    this.form.setValue(values);
  }

  public onSave(): void {
    const formValues = this.form.getRawValue();
    console.log("KanbanProductionCalendarDialogComponent formValues",formValues)
    this.dialogRef.close(formValues);
  }

  public onClose(): void{
    this.dialogRef.close();
  }
}
